
import styled from "styled-components";
import breakpoint from "styled-components-breakpoint";

const Footer = styled.div`
  height: auto;
  margin: 0;
  padding: 0;
  background-color: #1e1e1e;
  z-index: 100000;
  position: relative;
  /* margin-top: ${props => props.theme.spacing.s}rem; */

  h2{
    margin-bottom:  ${props => props.theme.spacing.xs}rem;
  }
  a{
    display: block;
    color: white;
    ${props => props.theme.setFontWithRhythm(props.theme.font.p.family, props.theme.font.p.size, props.theme.font.p.lineHeight)}
  }

  ${breakpoint("md")`
      height: 25vh;
  `}
`;

export default Footer;